
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-global-alert--default--large-spacing:var(--spacing-08);
  --sic-global-alert--default--medium-spacing:var(--spacing-05);
  --sic-global-alert--default--small-spacing:var(--spacing-04);
  --sic-global-alert--default--xsmall-spacing:var(--spacing-02);
}
`;